import { render, staticRenderFns } from "./JsonEdit.vue?vue&type=template&id=6b4496dd"
import script from "./JsonEdit.vue?vue&type=script&lang=js"
export * from "./JsonEdit.vue?vue&type=script&lang=js"
import style0 from "./JsonEdit.vue?vue&type=style&index=0&id=6b4496dd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports